import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input() logoId: boolean;
  @Input() logoImg: string;
  @Input() navItemList: any[];
  @Input() contactInfo: any;
  @Input() headeClass: string;

  openOption: any = null;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
  }

  toggleSubmenu(option: any, event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.openOption = this.openOption === option ? null : option;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.openOption = null;
    }
  }
}
